export default {
  methods: {
    getPicture(picture) {
      return require(`@/assets/celebrities/${picture}.png`)
    }
  }
}
